const Privacy = () => {
    return (
        <section className = "flex flex-col gap-4 flex-1 text-[#E6E6FA] overflow-y-auto p-16">
            <h2 className = "text-2xl text-center font-bold pb-12"><b>Privacy Policy</b></h2>
                <p>1. <b>Introduction</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        <b>Mintic</b> (“us”, “we”, or “our”) operates <b>mintic.io</b> (hereinafter referred to as <b>“Service”</b>).
                            Our Privacy Policy governs your visit to <b>ethpay.io</b>, and explains how we collect, safeguard and disclose 
                            information that results from your use of our Service.
                    </div>
                <p>2. <b>Types of Data Collected</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        We may also collect information that your browser sends whenever you visit our Service or when you access Service by 
                        or through any device (<b>“Usage Data”</b>).
                        <ul className = "mt-6 ml-6">
                            <li>0.1. <b>Personal data </b>such as mailing address, usernames, metamask account details and much more.</li>
                            <li>0.2. <b>Usage data</b></li>
                            <li>0.3. <b>Transaction history</b></li>
                        </ul>
                    </div>
                <p>3. <b>Use of Data</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        <ul>
                            <li>0.1. to provide and maintain our Service;</li>
                            <li>0.2. to notify you about changes to our Service;</li>
                            <li>0.3. to allow you to participate in interactive features of our Service when you choose to do so;</li>
                            <li>0.4. to provide customer support;</li>
                        </ul>
                    </div>
                <p>4. <b>Retention of Data</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. 
                        We will retain and use your Personal Data to the extent necessary to comply with our legal obligations.
                    </div>
                <p>5. <b>Disclosure of Data</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        Under certain circumstances, we may be required to disclose your Personal Data if required to do so by law or in 
                        response to valid requests by public authorities.
                    </div>
                <p>6. <b>Security of Data</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        The security of your data is important to us but remember that no method of transmission over the Internet or method of 
                        electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, 
                        we cannot guarantee its absolute security.
                    </div>
                <p>7. <b>Service Providers</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        We may employ third party companies and individuals to facilitate our Service (<b>“Service Providers”</b>), provide Service on 
                        our behalf, perform Service-related services or assist us in analysing how our Service is used.
                    </div>
                <p>8. <b>Payments</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        All payments are made securely and recored to required chains for security, visibility, credibility and accepted norms.
                        We will not store or collect your payment details. That information is provided directly to our third-party payment processors 
                        whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set 
                        by PCI-DSS as managed by the PCI Security Standards Council.
                    </div>
                <p>9. <b>Links to Other Sites</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed 
                        to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
                    </div>
                <p>10. <b>Contact Us</b></p>
                    <div className = "text-justify ml-12 mb-8">
                        If you have any questions about this Privacy Policy, please contact us by email: <b>support@mintic.io</b>.
                    </div>
        </section>
    )
}

export default Privacy